import { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { Logo, scrollToSection } from "./Shared";
import { WHATSAPP_URL } from "@/lib/site";

const LINKS = [
  { label: "Markets", hash: "#markets" },
  { label: "Performance", hash: "#performance" },
  { label: "Plans", hash: "#pricing" },
  { label: "Testimonials", hash: "#testimonials" },
  { label: "FAQ", hash: "#faq" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (hash) => {
    setOpen(false);
    scrollToSection(hash);
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-500 ${
        scrolled ? "border-line bg-obsidian/85 backdrop-blur-xl" : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <button onClick={() => go("#top")} className="cursor-pointer" aria-label="Globex home">
          <Logo />
        </button>

        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.hash)}
              className="text-sm font-medium text-slate-400 transition-colors duration-300 hover:text-slate-100"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            data-testid="nav-whatsapp-button"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-full border border-alpha/40 px-4 py-2 text-sm font-semibold text-alpha transition-all duration-300 hover:bg-alpha/10"
          >
            <MessageCircle size={16} />
            WhatsApp Desk
          </a>
          <button
            data-testid="nav-join-vip-button"
            onClick={() => go("#pricing")}
            className="rounded-full bg-gold px-5 py-2 text-sm font-bold text-obsidian transition-transform duration-300 hover:scale-[1.04]"
          >
            Join VIP
          </button>
        </div>

        <button
          data-testid="mobile-menu-button"
          className="text-slate-200 lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="border-t border-line bg-obsidian/95 backdrop-blur-xl lg:hidden">
          <div className="flex flex-col gap-1 px-6 py-4">
            {LINKS.map((l) => (
              <button
                key={l.hash}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                onClick={() => go(l.hash)}
                className="py-3 text-left text-base font-medium text-slate-300"
              >
                {l.label}
              </button>
            ))}
            <a
              data-testid="mobile-nav-whatsapp-button"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 flex items-center justify-center gap-2 rounded-full bg-alpha py-3 font-bold text-obsidian"
            >
              <MessageCircle size={18} /> WhatsApp the Desk
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
